import { useCallback } from 'react';

interface UseOTPValidationOptions {
  codeLength?: number;
  allowEmpty?: boolean;
}

export const useOTPValidation = ({
  codeLength = 6,
  allowEmpty = false
}: UseOTPValidationOptions = {}) => {
  const validateCode = useCallback((codeValue: string): string | null => {
    if (!codeValue || codeValue.trim() === '') {
      if (allowEmpty) {
        return null;
      }
      return 'O código não pode estar vazio';
    }
    
    const codeRegex = new RegExp(`^\\d{${codeLength}}$`);
    if (!codeRegex.test(codeValue.trim())) {
      return `O código deve ter exatamente ${codeLength} dígitos numéricos`;
    }
    
    return null;
  }, [codeLength, allowEmpty]);

  return {
    validateCode
  };
};
